import React from "react";
import Container from "./container";
import { cn } from "../lib/helpers";
import NewsCard from "./news-card";
import CategoryList from "./category-list";
import Pagination from "./pagination";

import * as styles from "../styles/components/news-list.module.css";

const NewsList = (props) => {

  const {
    news,
    category,
    newsCats,
    currentPage,
    numPages
  } = props;

  return (
    <div className={styles.root}>
      <Container>
        <div className="grid">
          <div className="col-12 col-md-4 col-lg-3">
            {newsCats && <CategoryList items={newsCats} ptSlug="blog-resources" ptTitle="Posts" category={category} />}
          </div>
          <div className="col-12 col-md-8 col-lg-9">
            <div className={cn("grid", styles.items)}>
              {news.map(({node: news}) => (
                <div key={news.id} className={cn("col-12 col-lg-6", styles.item)}>
                  <NewsCard news={news} title="h2" />
                </div>
              ))}
            </div>
            {numPages > 1 && <Pagination base={category ? "/blog-resources/"+category : "/blog-resources"} currentPage={currentPage} numPages={numPages} />}
          </div>
        </div>
      </Container>
    </div>
  );
}

export default NewsList;
